import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  ArrowDownward,
  ArrowUpward,
  HorizontalRule,
} from '@mui/icons-material';
import { getRankingPositionChangeLabel } from '@pages/Portal/Competitions/helpers';
import { IPositionChangeIndicator } from './interfaces';

export const PositionChangeIndicator: React.FC<IPositionChangeIndicator> = ({
  positionChange,
  previousRank,
  rank,
}): JSX.Element => {
  if (positionChange === 'same') {
    return <HorizontalRule sx={{ color: 'gray', fontSize: 18 }} />;
  }

  const isUp = positionChange === 'up';
  const color = isUp ? 'green' : 'red';
  const Icon = isUp ? ArrowUpward : ArrowDownward;
  const label =
    previousRank != null
      ? getRankingPositionChangeLabel(rank, previousRank, positionChange)
      : null;

  return (
    <Box
      component="span"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}
    >
      <Icon sx={{ color, fontSize: 18 }} />
      {label != null && (
        <Typography
          component="span"
          variant="caption"
          sx={{ color, fontWeight: 600, lineHeight: 1 }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};
